import { h } from 'preact';
import { Swiper, SwiperSlide } from 'swiper/react';
/* eslint-disable-next-line import/no-unresolved */
import SwiperCore, { Pagination } from 'swiper/core';
import ProductCard from '../collection/product-card';

SwiperCore.use([Pagination]);

const RecommendedProductsSlider = ({
  index,
  collectProducts,
  currentIndex,
}) => {
  const pagination = {
    el: `.custom-pagination-recommended${index}`,
    clickable: true,
    type: 'progressbar',
  };

  return (
    <div
      data-tab-content={index}
      className="relative hidden"
      data-content-active={index === currentIndex}
    >
      <div className="overflow-hidden swiper-wrap recommended-slider">
        <Swiper
          modules={[Pagination]}
          slidesPerView={'auto'}
          pagination={pagination}
          spaceBetween={8}
        >
          {collectProducts.map((data, index) => (
            <SwiperSlide key={`collectProduct-${index}`}>
              <ProductCard data={data} key={`product-card-${index}`} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div
        className={`custom-pagination-recommended${index} !absolute !-bottom-[30px] !left-0 !top-[auto] !w-[calc(100%-40px)] !h-[1px] !z-[1] !bg-grey-400 hidden laptop:block`}
      />
    </div>
  );
};

export default RecommendedProductsSlider;
